<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="6">
        <b-card header-tag="header">
          <div slot="header"><i class="icon-star"></i> Starboard settings</div>
          <div v-if="loading">
            <div class="sk-circle-fade float-left">
              <div class="sk-grid-cube"></div>
              <div class="sk-grid-cube"></div>
              <div class="sk-grid-cube"></div>
              <div class="sk-grid-cube"></div>
              <div class="sk-grid-cube"></div>
              <div class="sk-grid-cube"></div>
              <div class="sk-grid-cube"></div>
              <div class="sk-grid-cube"></div>
              <div class="sk-grid-cube"></div>
            </div>
            <h2 class="float-left ml-4">Loading starboard...</h2>
          </div>
          <div v-else>
            <div v-if="has_starboard === true">
            <div>
  <h4 class="smalltitle">Starboard Channel</h4>
  <p>
    Select the channel where starred messages will be posted. You can also
    remove the current channel to temporarily disable the starboard.
  </p>

  <multiselect
    v-model="starboard_channel"
    :options="textChannels"
    :allow-empty="true"
    :show-labels="false"
    label="name"
    track-by="id"
    placeholder="Select a starboard channel"
  >
    <template slot="singleLabel" slot-scope="{ option }">
      <span>
        <font-awesome-icon
          style="color: #72767d; margin-right: 5px"
          icon="hashtag"
        />
        {{ option.name }}
      </span>
    </template>

    <template slot="option" slot-scope="props">
      <div class="option__desc">
        <span class="option__title">
          <font-awesome-icon
            style="color: #72767d; margin-right: 5px"
            icon="hashtag"
          />
          {{ props.option.name }}
        </span>
      </div>
    </template>

    <template slot="noResult">
      <span>No channels found.</span>
    </template>
  </multiselect>

  <b-button
    v-if="starboard_channel"
    size="sm"
    variant="outline-danger"
    class="mt-2"
    @click="starboard_channel = null"
  >
    <font-awesome-icon icon="times" />
    Remove Starboard Channel
  </b-button>
</div>

<hr />
              <div>
                <h4 class="smalltitle">Star limit</h4>
                <p>
                  Sets the number of stars required for a message to be posted
                  to the starboard. Between 1 and 25 inclusive.
                </p>
                <b-form-group>
                  <b-input-group>
                    <b-form-input
                      type="number"
                      placeholder="3"
                      autocomplete="3"
                      v-model="threshold"
                      min="1"
                      max="25"
                      v-on:keydown="handleNonDecimalInput"
                      maxlength="2"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </div>
              <hr />
              <h6 class="teenytinytitle">
                Allow NSFW Content
                <c-switch
                  color="danger"
                  label
                  variant="pill"
                  v-bind="labelIcon"
                  v-model="nsfw"
                  id="nsfw_switch"
                  class="float-right"
                />
              </h6>
              <label
                class="col-form-label"
                for="nsfw_switch"
                style="color: #a8b6bd"
                >Embed images from messages starred in NSFW channels</label
              >
              <hr />
              <h6 class="teenytinytitle">
                Show Jump Link
                <c-switch
                  color="danger"
                  label
                  variant="pill"
                  v-bind="labelIcon"
                  v-model="show_jump"
                  id="jump_switch"
                  class="float-right"
                />
              </h6>
              <label
                class="col-form-label"
                for="jump_switch"
                style="color: #a8b6bd"
                >Adds a field with a jump link to the original message</label
              >
              <hr />
              <h6 class="teenytinytitle">
                Allow Self Starring
                <c-switch
                  color="danger"
                  label
                  variant="pill"
                  v-bind="labelIcon"
                  v-model="star_self"
                  id="self_switch"
                  class="float-right"
                />
              </h6>
              <label
                class="col-form-label"
                for="self_switch"
                style="color: #a8b6bd"
                >Counts stars added to members own messages</label
              >
              <hr />
              <h6 class="teenytinytitle">
                Lock Starboard
                <c-switch
                  class="float-right"
                  color="danger"
                  label
                  variant="pill"
                  v-bind="labelIcon"
                  v-model="locked"
                  id="lock_switch"
                />
              </h6>
              <label
                class="col-form-label"
                for="lock_switch"
                style="color: #a8b6bd"
                >Temporarily disable the starboard</label
              >
              <hr />
              <h6 class="teenytinytitle">
                Automatically Star New Entries
                <a
                  href="/get-premium"
                  v-if="!premium"
                  class="premium-pill"
                >
                  <i class="fas fa-crown"></i> Premium
                </a>
                <c-switch
                  color="danger"
                  label
                  variant="pill"
                  v-bind="labelIcon"
                  v-model="autostar"
                  :disabled="!this.premium"
                  id="auto_switch"
                  class="float-right"
                />
              </h6>
              <label
                class="col-form-label"
                for="auto_switch"
                style="color: #a8b6bd"
                >The bot will add a star to any fresh entries</label
              >
              <hr />
              <h6 class="teenytinytitle">
                <div>
                  <div>
                    <b-button
                      @click="showPicker = !showPicker"
                      :variant="premium ? 'success' : 'secondary'"
                      :disabled="!this.premium"
                    >
                      Set Starboard Emoji
                    </b-button>
                    <a
                      href="/get-premium"
                      v-if="!premium"
                      class="premium-pill"
                    >
                      <i class="fas fa-crown"></i> Premium
                    </a>

                    <span
                      v-if="!customEmojiImageUrl && this.premium"
                      style="margin: 4 4px; font-size: 30px"
                      class="float-right"
                    >
                      {{ this.selectedEmoji }}
                    </span>
                    <img
                      v-if="customEmojiImageUrl && this.premium"
                      :src="customEmojiImageUrl"
                      class="float-right"
                      style="width: 30px; height: 30px"
                    />
                  </div>
                  <keep-alive>
                    <Picker
                      v-if="showPicker"
                      :data="emojiIndex"
                      set="twitter"
                      :native="true"
                      theme="dark"
                      @select="onEmojiSelect"
                    />
                  </keep-alive>
                </div>
              </h6>
              <label
                class="col-form-label"
                for="auto_switch"
                style="color: #a8b6bd"
              >
                Add an emoji instead of ⭐ for starboard reactions
              </label>
              <hr />

              <b-form-group>
                <label for="blacklist" class="teenytinytitle"
                  >Ignore stars in these channels</label
                >
                <multiselect
                  v-model="blacklist"
                  :options="groupedChannels"
                  :multiple="true"
                  group-values="channels"
                  group-label="category"
                  :group-select="false"
                  label="name"
                  track-by="id"
                  id="blacklist"
                >
                  <template slot="tag" slot-scope="{ option, search, remove }">
                    <span
                      class="multiselect__tag channelpicker__tag"
                      :style="{ borderColor: '#eee' }"
                    >
                      <i
                        aria-hidden="true"
                        tabindex="1"
                        @keydown.enter.prevent="remove(option)"
                        @mousedown.prevent="remove(option)"
                        class="multiselect__tag-icon channelpicker_icon"
                        :style="{ backgroundColor: '#eee' }"
                      ></i>
                      <font-awesome-icon
                        style="color: #999; margin-right: 3px"
                        icon="hashtag"
                      />
                      <span class="defaultcursor" v-text="option.name"></span>
                    </span>
                  </template>
                  <template slot="option" slot-scope="props">
                    <div class="option__desc">
                      <span class="option__title">
                        <font-awesome-icon
                          style="color: #72767d"
                          :icon="
                            !props.option['$isLabel']
                              ? 'hashtag'
                              : 'chevron-down'
                          "
                        />
                        {{ props.option.name || props.option.$groupLabel.name }}
                      </span>
                    </div>
                  </template>
                </multiselect>
              </b-form-group>
              <div slot="footer" v-if="has_starboard">
                <b-button
                  class="float-right"
                  variant="primary"
                  v-on:click="patch_starboard"
                  >Save</b-button
                >
              </div>
            </div>
            <div v-else>
              <h4 class="smalltitle">
                No starboard found
                <font-awesome-icon
                  style="color: #888"
                  :icon="['fas', 'question-circle']"
                  class="mx-2"
                  id="restricted_question"
                />
                <b-popover
                  triggers="hover"
                  placement="top"
                  target="restricted_question"
                >
                  <h5 class="tinytitle">What is a Starboard?</h5>
                  It's like democratic pins. After you make a Starboard channel,
                  users can react to a message with a ⭐ to 'vote' to display
                  that post on the starboard. Once the message gets enough ⭐
                  reactions, Carlbot posts it onto the starboard. Give it a try!
                  I'm sure your server will like it.
                </b-popover>
              </h4>
              <h6 class="teenytinytitle">
                You can create a starboard by choosing a name for the channel
                you want created
              </h6>
              <b-form-group>
                <b-input-group>
                  <div class="input-group-prepend">
                    <div class="input-group-text">#</div>
                  </div>
                  <b-form-input
                    type="text"
                    pattern="[a-z0-9-_]{1,32}"
                    v-model="starboard_name"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button v-on:click="create_starboard" variant="primary"
                      >Create</b-button
                    >
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from "vue";
import { Switch as cSwitch } from "@coreui/vue";
import { Callout } from "@coreui/vue";
import VueNotifications from "vue-notifications";
import miniToastr from "mini-toastr";
import Multiselect from "vue-multiselect";
import data from "emoji-mart-vue-fast/data/all.json";
import { Picker, EmojiIndex } from "emoji-mart-vue-fast";

import "emoji-mart-vue-fast/css/emoji-mart.css";

// Mutate data to support all Unicode emojis in their categories
Object.values(data.emojis).forEach(emoji => {
  if (emoji.f === false) {
    emoji.f = true;
    emoji.native_fallback = true;
  }
});

const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn",
};
miniToastr.init({ types: toastTypes });

function toast({ title, message, type, timeout, cb }) {
  return miniToastr[type](message, title, timeout, cb);
}

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast,
};

const CUSTOM = [];
for (let i = 0; i < 26; i++) {
  const char = String.fromCharCode(97 + i);
  CUSTOM.push({
    name: 'Regional Indicator Symbol Letter ' + char.toUpperCase(),
    short_names: ['regional_indicator_' + char],
    id: 'regional_indicator_' + char,
    native: String.fromCodePoint(0x1f1e6 + i),
    imageUrl: `https://cdn.jsdelivr.net/gh/twitter/twemoji@latest/assets/72x72/${(0x1f1e6 + i).toString(16)}.png`,
    keywords: ['alphabet', 'letter', char],
    custom: true
  });
}

let emojiIndex = new EmojiIndex(data, {
  custom: CUSTOM,
});

Vue.use(VueNotifications, options);

export default {
  name: "dashboard",
  components: {
    Callout,
    cSwitch,
    Multiselect,
    Picker,
  },
  data: function () {
    return {
      selected: "Month",
      labelIcon: {
        dataOn: "\u2713",
        dataOff: "\u2715",
      },
      nsfw: false,
      star_self: false,
      show_jump: true,
      locked: false,
      autostar: false,
      premium: false,
      threshold: 3,
      channels: [],
      blacklist: [],
      loading: true,

      emojiIndex: emojiIndex,
      selectedEmoji: null,
      customEmojiImageUrl: null,
      showPicker: false,
      server_emojis: [],
      custom: CUSTOM,

      has_starboard: false,
      starboard_name: "starboard",
      starboard_channel: null,
    };
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: "Success!",
      message: "Setting applied",
    },
    showInfoMsg: {
      type: VueNotifications.types.info,
      title: "No changes",
      message: "That's your current star limit.",
    },
    showWarnMsg: {
      type: VueNotifications.types.warn,
      title: "Uh-oh",
      message: "Pick a number between 1 and 25.",
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: "Uh-oh",
      message: "Pick a number between 1 and 25.",
    },
  },
  methods: {
async patch_starboard() {
      const threshold = Number(this.threshold);
      if (!Number.isInteger(threshold) || threshold < 1 || threshold > 25) {
        return this.showErrorMsg({ message: "Pick a number between 1 and 25." });
      }

      const channelId = this.starboard_channel
        ? String(this.starboard_channel.id)
        : null;

      try {
        await this.axios.patch(
          `/api/v1/servers/${this.$route.params.guild_id}/starboard`,
          {
            nsfw: this.nsfw,
            star_self: this.star_self,
            threshold,
            show_jump: this.show_jump,
            locked: this.locked,
            autostar: this.premium ? this.autostar : false,
            blacklist: this.blacklist.map(x => String(x.id)),
            emoji: this.selectedEmoji || null,
            channel_id: channelId,
          }
        );
        if (channelId === null) {
          this.has_starboard = false;
          this.starboard_channel = null;
        }
        this.showSuccessMsg();
        await this.loadStarboard(this.$route.params.guild_id);
      } catch (error) {
        console.error("Failed to save starboard:", error);
        this.showErrorMsg({ message: (error.response && error.response.data && error.response.data.description) || "Failed to save starboard settings." });
      }
    },

    async loadStarboard(guildId) {
  this.loading = true;
  this.$Progress.start();

  try {
    const { data: response } = await this.axios.get(
      `/api/v1/servers/${guildId}/starboard`
    );

    // Load channels and premium information
    this.channels = (response.channels || []).map(channel => ({
      ...channel,
      id: String(channel.id),
      parent_id:
        channel.parent_id != null
          ? String(channel.parent_id)
          : null,
    }));

    this.premium = !!response.premium;
    this.server_emojis = response.server_emojis || [];

    // Check whether a starboard is configured
    const savedChannelId =
      response.channel_id != null
        ? String(response.channel_id)
        : null;

    this.has_starboard = !!savedChannelId;

    // Restore the saved starboard channel
    if (savedChannelId) {
      let selectedChannel = this.textChannels.find(
        channel => String(channel.id) === savedChannelId
      );

      // Fallback when the saved channel is not in the API channel list
      if (!selectedChannel) {
        console.warn(
          "Saved starboard channel missing from API channels:",
          savedChannelId
        );

        selectedChannel = {
          id: savedChannelId,
          name: `Unknown Channel (${savedChannelId})`,
          type: 0,
          position: 9999,
          missing: true,
        };

        // Add fallback to the dropdown so Vue Multiselect
        // can display the selected value
        this.channels.push(selectedChannel);
      }

      this.starboard_channel = selectedChannel;
    } else {
      this.starboard_channel = null;
    }

    console.log("Saved channel ID:", savedChannelId);
    console.log("Selected starboard channel:", this.starboard_channel);

    // Restore starboard settings
    this.nsfw = !!response.nsfw;
    this.star_self = !!response.star_self;
    this.show_jump = response.show_jump !== false;

    this.threshold =
      response.threshold == null ? 3 : response.threshold;

    this.current_threshold = this.threshold;
    this.autostar = !!response.autostar;
    this.locked = !!response.locked;

    // Restore blacklisted channels
    this.blacklist = this.channels.filter(channel =>
      (response.blacklist || []).some(
        id => String(id) === String(channel.id)
      )
    );

    // Restore selected emoji
    this.selectedEmoji = response.emoji || null;
    this.customEmojiImageUrl = null;

    if (
      response.emoji &&
      /^\d+$/.test(String(response.emoji))
    ) {
      const found = this.server_emojis.find(
        emoji =>
          String(emoji.id) === String(response.emoji)
      );

      const extension =
        found && found.animated ? "gif" : "png";

      this.customEmojiImageUrl =
        `https://cdn.discordapp.com/emojis/${response.emoji}.${extension}?v=1`;
    }

    // Restore custom server emojis
    this.custom = [...CUSTOM];

    this.server_emojis.forEach(emoji => {
      this.custom.push({
        name: emoji.name,
        short_names: [String(emoji.id)],
        id: String(emoji.id),
        imageUrl:
          `https://cdn.discordapp.com/emojis/${emoji.id}.` +
          `${emoji.animated ? "gif" : "png"}?v=1`,
        custom: true,
        custom_id: String(emoji.id),
      });
    });

    this.emojiIndex = new EmojiIndex(data, {
      custom: this.custom,
    });

  } catch (error) {
    console.error("Failed to load starboard:", error);

    this.showErrorMsg({
      message: "Failed to load starboard settings.",
    });

  } finally {
    this.loading = false;
    this.$Progress.finish();
  }
},
        emoji_from_id(id) {
      if (!id) return null;

      // Map raw Unicode regional indicators to our custom IDs
      const cp = id.codePointAt(0);
      if (cp >= 0x1f1e6 && cp <= 0x1f1ff && [...id].length === 1) {
        id = 'regional_indicator_' + String.fromCharCode(97 + (cp - 0x1f1e6));
      }

      const numEmojisRegex = /[\u0030-\u0039\u20E3]/g;
      if (numEmojisRegex.test(id)) {
      } else if (id.length > 2 && parseInt(id)) {
        let match = this.emojiIndex._custom.find((x) => x.custom_id == id);
        if (match) {
          id = match.id;
        }
      }
      const maybe_emoji = this.emojiIndex.findEmoji(id, null);
      if (maybe_emoji) {
        if (maybe_emoji._data && maybe_emoji._data.native_fallback) {
          // Can't mutate frozen object, return a decorated clone
          return { ...maybe_emoji, fallback: true };
        }
        return maybe_emoji;
      }

      // Final fallback for foreign emojis / unknown Unicode
      return {
        id: id,
        native: id,
        name: id,
        colons: `:${id}:`,
        custom: false,
        fallback: true
      };
    },
    onEmojiSelect(emoji) {
      // Store the selected emoji in a variable
      (this.selectedEmoji = (emoji.custom && emoji._data)
        ? (emoji._data.custom_id || emoji._data.native)
        : emoji.native),
        (this.customEmojiImageUrl = emoji.custom ? emoji.imageUrl : null);

      // Hide picker after selection (optional)
      this.showPicker = false;
      console.log(emoji);
    },

    handlethreshold(v) {
      if (
        !(this.threshold < 1 || this.threshold > 25) &&
        this.threshold != this.current_threshold
      ) {
        this.current_threshold = this.threshold;
        this.handleChange("threshold", this.threshold);
      } else if (this.threshold == this.current_threshold) {
        this.showInfoMsg();
      } else {
        this.showWarnMsg();
      }
    },
    handleChange(e, v) {
      // PATCH requires a complete payload, including channel_id.
      this[e] = v;
      return this.patch_starboard();
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    create_starboard() {
      this.axios
        .post("/api/v1/servers/" + this.$route.params.guild_id + "/starboard", {
          name: this.starboard_name,
          author: this.$store.state.discord_user.id,
        })
        .then(() => {
          this.has_starboard = true;
        });
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.loadStarboard(to.params.guild_id);
    next();
  },
  created() {
    this.loadStarboard(this.$route.params.guild_id);
  },
  computed: {
  textChannels() {
  return this.channels
    .filter((channel) => Number(channel.type) === 0)
    .sort((a, b) => a.position - b.position);
},
    groupedChannels() {
      let groups = [
        {
          category: {
            id: null,
            name: "Uncategorized",
          },
          channels: [],
        },
      ];
      let currentGroup = groups[0];
      for (let chn of this.channels.sort((a, b) => a.position - b.position)) {
        if (chn.type === 4) {
          currentGroup = { category: chn, channels: [] };
          groups.push(currentGroup);
        }
      }
      for (let chn of this.channels.sort((a, b) => a.position - b.position)) {
        if (chn.type === 4) {
          continue;
        }
        currentGroup = groups.find((g) => {
          return g.category.id == chn.parent_id;
        });
        if (!currentGroup) {
          continue;
        }
        currentGroup.channels.push(chn);
      }
      return groups;
    },
  },
};
</script>

<style>
.emoji-mart {
  background-color: #3a4149;
  border: 1px solid #202225;
}

.emoji-mart-category .emoji-mart-category-label span {
  color: #eee;
  background-color: #3a4149;
  border-radius: 5px;
}
.emoji-mart-search input {
  background-color: #515b65;
  color: #eee;
  border: 1px solid #202225;
}

.emoji-mart-bar {
  border: 0 solid #202225;
}

.emoji-mart-preview-data .emoji-mart-preview-name {
  color: #eee;
}

.emoji-mart-category .emoji-mart-emoji:hover:before {
  background-color: #515b65;
}

.emoji-mart-category .emoji-mart-emoji:hover:before {
  opacity: 1;
}

.emoji-mart-emoji.displayed-emoji {
  padding: 0px 12px;
}

.premium-pill {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 2px 9px;
  margin-left: 8px;
  background: rgba(248, 203, 0, 0.12);
  border: 1px solid rgba(248, 203, 0, 0.4);
  color: #f8cb00;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-radius: 999px;
  text-decoration: none;
  vertical-align: middle;
}
.premium-pill:hover {
  background: rgba(248, 203, 0, 0.2);
  color: #ffd83d;
  text-decoration: none;
}
.premium-pill i {
  font-size: 9px;
}
</style>
